import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, euro } from "@/lib/api";
import { Plus } from "lucide-react";

export default function Promos() {
  const [promos, setPromos] = useState([]);
  const [amount, setAmount] = useState(5);
  const [days, setDays] = useState(30);
  const [code, setCode] = useState("");
  const load = () => api.get("/admin/promos").then(({ data }) => setPromos(data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    try {
      await api.post("/admin/promos", { amount: parseFloat(amount), expires_in_days: parseInt(days), code: code || null });
      toast.success("Code créé"); setCode(""); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };
  const toggle = async (id) => { await api.patch(`/admin/promos/${id}`); load(); };

  return (
    <div className="max-w-3xl">
      <h1 className="font-serif text-3xl font-bold text-brand-green mb-6">Codes promo</h1>
      <div className="bg-white rounded-xl border border-brand-green/10 p-5 mb-6">
        <h2 className="font-serif text-lg font-bold text-brand-green mb-3">Générer un code (montant fixe, usage unique)</h2>
        <div className="grid sm:grid-cols-4 gap-3 items-end">
          <div><label className="text-xs text-brand-green/60">Montant (€)</label><input data-testid="promo-amount" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} className="w-full h-11 rounded-lg border border-brand-green/20 px-3" /></div>
          <div><label className="text-xs text-brand-green/60">Expire dans (j)</label><input type="number" value={days} onChange={(e) => setDays(e.target.value)} className="w-full h-11 rounded-lg border border-brand-green/20 px-3" /></div>
          <div><label className="text-xs text-brand-green/60">Code (optionnel)</label><input data-testid="promo-code-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Auto" className="w-full h-11 rounded-lg border border-brand-green/20 px-3" /></div>
          <button data-testid="create-promo" onClick={create} className="h-11 rounded-lg bg-brand-gold text-brand-green font-semibold flex items-center justify-center gap-1"><Plus className="w-4 h-4" /> Créer</button>
        </div>
      </div>
      <div className="bg-white rounded-xl border border-brand-green/10 overflow-hidden">
        <table className="w-full text-sm" data-testid="promos-table">
          <thead className="bg-brand-sage text-brand-green/70 text-xs uppercase"><tr>{["Code", "Montant", "Expire", "État", ""].map((h) => <th key={h} className="text-left p-3">{h}</th>)}</tr></thead>
          <tbody>
            {promos.map((p) => (
              <tr key={p.id} className="border-t border-brand-green/5">
                <td className="p-3 font-mono font-bold text-brand-green">{p.code}</td>
                <td className="p-3">{euro(p.amount)}</td>
                <td className="p-3 text-brand-green/60">{(p.expires_at || "").slice(0, 10)}</td>
                <td className="p-3">{p.used ? <span className="text-brand-green/50">Utilisé</span> : p.active ? <span className="text-brand-green font-semibold">Actif</span> : <span className="text-brand-alert">Désactivé</span>}</td>
                <td className="p-3">{!p.used && <button onClick={() => toggle(p.id)} className="text-sm underline text-brand-green">{p.active ? "Désactiver" : "Réactiver"}</button>}</td>
              </tr>
            ))}
            {promos.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-brand-green/50">Aucun code</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
